// ============================================================================
// phosphera — Vite entry point
// ----------------------------------------------------------------------------
// IMPORTANT: ES module `import` statements are hoisted and execute in order,
// BEFORE any other top-level code in this file. So the boot sequence must be
// expressed purely as import order:
//
//   1. styles        — themed first paint
//   2. scaffold      — creates #app / #chatRoot / #fxWrapper / .bg-base
//                       BEFORE the app's top-level code touches them
//   3. firebase      — sets up window.phospheraAuth, fires the ready event
//   4. app           — waits for that event, then runs
//
// The app + firebase still talk through window.phospheraAuth and the
// 'phosphera-firebase-ready' event exactly as before — no behaviour changes.
// ============================================================================

import './styles/main.css';
import './scaffold.js';        // MUST come before ./app/index.js
import './firebase/index.js';
import './app/index.js';

// Race guard: if firebase finished initialising and dispatched
// 'phosphera-firebase-ready' before app/index.js attached its listener,
// re-dispatch once on the next tick so the app's handler still fires.
// (window.phospheraReady is set true by firebase/index.js when ready.)
queueMicrotask(() => {
  if (window.phospheraReady) {
    window.dispatchEvent(new Event('phosphera-firebase-ready'));
  }
});
